import React, { useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Loading from '../loading/Loading';
import { setupApp } from '../../actions';
import { usePageTitle } from '../../hooks';
import { PIRedirect } from '../nav';
import websiteAccessKey from '../../cache/websiteAccessKey';
import OrderTypePicker from './OrderTypePicker';
import { getCart } from '../../selectors';
import api from '../../api/paidit-api';

const Home = ({ history, location, ...props }) => {
    const dispatch = useDispatch();
    const token = useSelector(state => state.app.token);
    const chainId = useSelector(state => state.business.chain.id);
    const isLoading = useSelector(state => state.loading.queue.length > 0);
    const cart = useSelector(state => getCart(state));

    usePageTitle('pageTitles.chooseOrderType');

    useEffect(() => {
        if (chainId && !token) {
            api({ alertError: null, trackLoading: !token }).setup(chainId, websiteAccessKey)
                .then(data => dispatch(setupApp(data)))
                .catch(() => history.replace(`/notFound`));
        }
    }, [token, chainId, history, dispatch]);

    if (!chainId) {
        return <PIRedirect to="/notFound" />;
    }

    if (!token) {
        return <Loading showLoading={isLoading} />;
    }

    if (cart.cartId) {
        return <PIRedirect to="/order" />;
    }

    return (
        <Fragment>
            <Loading showLoading={isLoading} />
            {/* <Login /> */}
            <OrderTypePicker />
        </Fragment>
    );
};

export default Home;
